// Local channel edits (SPEC F6). The shipped registry lives in
// public/crate/channels.json; this table holds what the user added or changed.

import type { Channel } from '../../data/types';
import { getDb } from '../schema';

export async function listChannels(): Promise<Channel[]> {
  const all = await getDb().channels.toArray();
  return all.sort((a, b) => a.name.localeCompare(b.name));
}

/** Adds a channel (no localId) or updates one. Returns its localId. */
export async function saveChannel(channel: Channel): Promise<number> {
  const db = getDb();
  if (channel.localId !== undefined) {
    await db.channels.put(channel);
    return channel.localId;
  }
  return (await db.channels.add(channel)) as number;
}

export const removeChannel = (localId: number): Promise<void> => getDb().channels.delete(localId);

/** Import replaces the local list in one transaction. */
export async function replaceChannels(channels: Channel[]): Promise<void> {
  const db = getDb();
  await db.transaction('rw', db.channels, async () => {
    await db.channels.clear();
    // A new localId is assigned to each; the old ones don't carry over.
    await db.channels.bulkAdd(channels.map((c) => ({ ...c, localId: undefined })));
  });
}
